<template>
	<div class="form">
        <h1>Lisandro<br/>Aristimuño</h1>

        <div v-if="!send">
            <h2>Descarga tu disco digital</h2>
            <router-link to="/" class="vodal-confirm-btn">Volver</router-link>
        </div>

        <div class="download" v-if="send">
            <img src="@/assets/images/download.png" class="center-block"/>
            <h1>Descargado!</h1>
            <p>La descarga del disco se completó con éxito.</p>
        </div>

        <vodal :show="show" animation="rotate" @hide="show = false" :height="200" :width="350" >
            <div class="content">
                <div>{{modalError}}</div>
                <button class="vodal-confirm-btn" @click="show = false">Aceptar</button>
            </div>
        </vodal>
    </div>
</template>

<script>
    import axios from "axios"
    import Vodal from 'vodal';

    import { mapState } from 'vuex'

    export default {
    	name: 'Download',
        components: {
            Vodal
        },
        data() {
            return {
                send: false,
                show: false,
                code: false,
                modalError: ''
            }
        },
        computed: {
            ...mapState(['requests'])
        },
        methods: {
            async checkCode(e) {
                this.btn = false

                var params = this.requests.download.playload

                params.codigo = this.code

                let datos = axios.get(this.requests.download.endpoint, {params: params}).then(res => {
                    if (res.data.code == '1') {
                        var anchor = document.createElement('a')
                        anchor.href = res.data.result
                        anchor.download = res.data.result
                        document.body.appendChild(anchor)
                        anchor.click()

                        this.send = true
                    }

                    else {
                        this.modalError = res.data.message
                        this.show = true
                    }
                })

                this.btn = true
            }
        },
        created () {
            this.code = this.$route.params.id

            this.checkCode()
        }
    }
</script>